import { useEffect } from "react";

const useMountEffect = (fun, dependency) => useEffect(fun, dependency);

export default useMountEffect;
